const faqCats = {
    'howitworks': {
        id: 'howitworks',
        text: 'How it works',
    },
    'findorders': {
        id: 'findorders',
        text: 'Find orders',
    },
    'ordersinprogress': {
        id: 'ordersinprogress',
        text: 'Orders in progress',
    },
    'submission': {
        id: 'submission',
        text: 'Submission of the final paper',
    },
    'paymentdetails': {
        id: 'paymentdetails',
        text: 'Payment Details',
    },
    'other': {
        id: 'other',
        text: 'Other',
    },
    'quality': {
        id: 'quality',
        text: 'Quality Rates',
    },
    'writer': {
        id: 'writer',
        text: 'Writer Group',
    },
    'termination': {
        id: 'termination',
        text: 'Termination of Cooperation',
    },
    'contact': {
        id: 'contact',
        text: 'Contact us',
    },
};

const guidesCats = {
    'general': {
        id: 'general',
        text: 'General',
    },
    'paymentmethods': {
        id: 'paymentmethods',
        text: 'Payment methods',
    },
    'academicwriting': {
        id: 'academicwriting',
        text: 'Academic writing',
    },
    'formattingstyles': {
        id: 'formattingstyles',
        text: 'Formatting styles',
    },
    'badorders': {
        id: 'badorders',
        text: 'Samples. Bad orders',
    },
    'goodorders': {
        id: 'goodorders',
        text: 'Samples. Good orders',
    },
};

const faqList = {
    'Who are my team leaders?': {
        title: 'Who are my team leaders?',
        category: 'howitworks',
        text: 'They run writer platform day-to activities, communicate with clients, forward your messages to clients and vice versa, resolve the basic conflicts. Contact through the messaging system, Skype (Livingston_Research), email (support@liv-research.com) or direct phone number for any details, questions, etc. One of the team leaders is always online (except for short breaks), so you should get instant answers to Skype messages and phone calls; regular system messages will be answered within 1,5 hours. You can track if there is a team leader currently available with the special section in your account. The team leaders are your primary contacts in Livingston Research, they will be able to assist you with the vast majority of questions or issues you might have.',
    },
    'How can I contact my team leaders?': {
        title: 'How can I contact my team leaders?',
        category: 'howitworks',
        text: 'Email <a href="mailto:support@liv-research.com">support@liv-research.com</a>, Skype Livingston_Research or phone <a href="tel:+380957362473">+380957362473, </a><a href="tel:+74991123285">+74991123285</a>, messages section on each and every accepted order.',
    },
    'Who is my success manager?': {
        title: 'Who is my success manager?',
        category: 'howitworks',
        text: "Writer Success Manager is an assigned to you person who is interested in you being a successful Writer in our company. This person will answer all your questions regarding the platform and will guide you through it. He's like your personal helper on the platform who will recommend you nice orders from time to time and will discuss the useful feedback from the Grader with you.",
    },
    'How can I contact my success manager?': {
        title: 'How can I contact my success manager?',
        category: 'howitworks',
        text: 'Email <a href="mailto:success@liv-research.com">success@liv-research.com</a> Feel free to ask this person all your questions not related to some specific orders directly, but related to your work as writer.',
    },
    'Who decides which orders I get?': {
        title: 'Who decides which orders I get?',
        category: 'findorders',
        text: 'You are the one who is responsible for your workload. Thus, you are the one who chooses which assignments to take care of. Nevertheless, our team leaders are responsible for order allocation. Thus, you may get recommendations based on your preferred subjects. This is not decided at random – they take into close consideration the specifics of the task, the education, and qualifications of the writer, his/her score, rejection rate and current workload. If you have any remarks about the type of orders you receive, your workload or your availability, make sure you discuss your concerns with one of the team-leaders.',
    },
    'How do I accept the order?': {
        title: 'How do I accept the order?',
        category: 'findorders',
        text: 'We recommend our writers checking the pool of available orders a couple of times per day. Feel free to use filters to find the most suitable ones. The filters by the subject/deadline/amount of pages are extremely useful during the High Season. Open the order that seems to be suitable, click on "Reserve" button, so no one else can accept it for the next 15 minutes, read all the instructions. If everything is fine and you realize you can complete it successfully within the given deadline, please click on Accept button. If you do not feel you can successfully complete it, click on Reject. Feel free to contact our team leaders any time if you need additional clarifications to successfully complete the order. The same is to be done on recommended orders.',
    },
    'Saved orders': {
        title: 'Saved orders',
        category: 'findorders',
        text: 'You can save suitable orders to the wish list by marking them with a start on the left of order number. All saved orders you can find in Saved orders section. Once the order is accepted by other writer it is not more available for other writers and could dissapear from your with list.',
    },
    'Reserved orders': {
        title: 'Reserved orders',
        category: 'findorders',
        text: 'Reservation of orders is possible for 15 minutes. It means that this order is not visible for other writer during this 15 minutes.',
    },
    'I want to cancel an order I just accepted, how can I do that?': {
        title: 'I want to cancel an order I just accepted, how can I do that?',
        category: 'findorders',
        text: 'That is not allowed; once you accept an order it is your responsibility to finish it. Failure to perform an order will result in a 200% fine unless you contact our team leaders right after the order is accepted.',
    },
    'The order form states that that the paper should be 4 pages, but the order description states that it should be 9 pages. What should I do?': {
        title: 'The order form states that that the paper should be 4 pages, but the order description states that it should be 9 pages. What should I do?',
        category: 'findorders',
        text: 'You should point out the inconsistency to the client via our messaging system or contact our team leaders directly. If the client does not reply, you should always write as many pages as the order form states (4 in this case), as that is the number the client has paid for. ',
    },
    'What should I do if no formatting style is specified by the client?': {
        title: 'What should I do if no formatting style is specified by the client?',
        category: 'ordersinprogress',
        text: 'If you accept any writing assignment and no formatting style is indicated, you are to format the paper as per MLA guidelines;',
    },
    'What information should be cited?': {
        title: 'What information should be cited?',
        category: 'ordersinprogress',
        text: "All the information that is not your personal opinion such as a direct quote, indirect quote, any statistical data that is not a general knowledge, someone's point of view, must have an in-text citation of the source it was taken from. Thus each source in the reference list must have at least 1 in text citation.",
    },
    'Should I cite the statistical data?': {
        title: 'Should I cite the statistical data?',
        category: 'ordersinprogress',
        text: 'It is crucial to cite all the outside information, including the statistical data, graphs, charts, etc. Otherwise, this information is considered to be made up.',
    },
    'I don’t know how to properly cite with XXX style. What should I do?': {
        title: 'I don’t know how to properly cite with XXX style. What should I do?',
        category: 'ordersinprogress',
        text: 'We would recommend you using the available Templates for each formatting style. You can download these templates from your personal account in the Guides section. Moreover, there are useful links in these templates; you are welcome to follow them to get more information how to format your paper properly.',
    },
    'Can I use Wikipedia as a source for my paper?': {
        title: 'Can I use Wikipedia as a source for my paper?',
        category: 'ordersinprogress',
        text: 'No, unless stated otherwise by the client, Wikipedia is not a viable source',
    },
    'Can you find some sources for this paper for me?': {
        title: 'Can you find some sources for this paper for me?',
        category: 'ordersinprogress',
        text: 'It is the responsibility of the writer to find all sources for his paper. Use only English credible sources from the native speaking countries.  The team leader can ask the client to provide electronic versions of the sources, but he will not look for sources instead of you. You can always clarify whether the client has some specific sources to use. ',
    },
    'What should I do if the client did not specify the amount of sources to be used?': {
        title: 'What should I do if the client did not specify the amount of sources to be used?',
        category: 'ordersinprogress',
        text: 'We recommend to use at least 1 source per 1 page especially on the orders 2 pages+, unless the client stated otherwise by the client. Still, contact our team leaders to clarify this information with the client. ',
    },
    'What should I do if I am to provide the client with a draft or more than one file as a final paper?': {
        title: 'What should I do if I am to provide the client with a draft or more than one file as a final paper?',
        category: 'ordersinprogress',
        text: 'If you happen to upload a draft or outline, or your order is separated into different parts, please upload them via messages in the system. Only the last file should be uploaded as a final paper in the system as per your initial deadline.',
    },
    'I have to delay an order I have accepted. What should I do?': {
        title: 'I have to delay an order I have accepted. What should I do?',
        category: 'ordersinprogress',
        text: 'Ask the team leader permission to do so and clarify if the extension on the order is possible. Unless the delay is allowed, you will be fined.',
    },
    'What is considered plagiarism?': {
        title: 'What is considered plagiarism?',
        category: 'ordersinprogress',
        text: '<ul><li>Direct copying from a source without mentioning the author; </li><li>Paraphrasing the source without mentioning the author;</li><li>Copying from your previous papers (internal plagiarism);</li><li>Having in-text citation without having this sources listed in the Work Cited Page or likewise;</li><li>Failing to put a quotation in quotation marks;</li><li>Giving incorrect information about the source of a quotation;</li><li>Giving incorrect information about the source of a quotation;</li><li>Changing words but copying the sentence structure of a source without giving credit;</li><li>Copying so many words or ideas from a source that it makes up the majority of your work.</li></ul>',
    },
    'What sources are considered credible?': {
        title: 'What sources are considered credible?',
        category: 'ordersinprogress',
        text: '<ul><li>Articles in scholarly journals, especially peer-reviewed articles;</li><li>Websites of credible institutions (.gov; .edu);</li><li>NB Wikipedia, blogs are not credible</li></ul>',
    },
    'What is a thesis statement?': {
        title: 'What is a thesis statement?',
        category: 'ordersinprogress',
        text: 'A thesis statment is an argument that will be discussed in the paper and should be supported with specific evidence; Usually this is the last sentence of the introduction. Feel free to follow the link below to get more information : https://awc.ashford.edu/essay-dev-thesis-statements.html',
    },
    'How do I complete a good power point presentation?': {
        title: 'How do I complete a good power point presentation?',
        category: 'ordersinprogress',
        text: '<p>Power Point Presentation has to be :</p><ul><li>visually appealing (good background, font and pictures / diagrams) ;</li><li>readable and not overloaded with text (usually up to 5 main points);</li><li>the content of the slide is explained in speaker notes in full sentences. You can either do it in the presentation itself in the "speaker notes" field or provide the client with the .doc file labeling each slide (slide#1....; slide#2...; slide#3....; etc.)</li><li>title slide and references are not included in overall slide count;</li><li>it is a must to format the presentation as well.</li><ul>',
    },
    'How do I get paid for the assignment submitted?': {
        title: 'How do I get paid for the assignment submitted?',
        category: 'submission',
        text: 'Once the order changes the status from "In Work" to "Completed", the compensation for the order goes to Pending balance first and in 15 days it will be automatically transferred to your Available balance. Available balance is working as accumulating system where all the compensations are summed up and awaiting your request for the withdrawal.',
    },
    'What should I submit if I am to complete an online assignment?': {
        title: 'What should I submit if I am to complete an online assignment?',
        category: 'submission',
        text: "Pay close attention to Quizzes/online tests. In such orders, you are to log into client's dashboard and complete the assignment described in the order. It is a must to upload a screenshot that the test has been completed taken from the client's dashboard as a final paper in our system. You can use Lightshot free tool to make the screenshots (https://app.prntscr.com/en/download.html). Please note that no information from your computer should be there like your tabs, current time and so on.",
    },
    'What should I do if the plagiarism is detected once the final paper is submitted?': {
        title: 'What should I do if the plagiarism is detected once the final paper is submitted?',
        category: 'submission',
        text: "<p>Each and every file you upload as a final paper is checked for plagiarism straight forward. If the plagiarism is detected, feel free to open the report available. If there is a plagiarism indeed, please rewrite the highlighted parts and cite the information correctly. Afterward, re-upload the final paper. </p><p>If you happen to see your citations or client's questions (especially on Question-Answer type of orders) highlighted as plagiarized , contact our team leaders to double check it. If everything is alright, they will override the report.</p>",
    },
    'The client keeps sending revision requests with new tasks every time, what should I do?': {
        title: 'The client keeps sending revision requests with new tasks every time, what should I do?',
        category: 'submission',
        text: 'Revision requests can only be based on initial instructions. Inform your team leader about the issue. If the revision request contradicts to the initial instructions, we will ask the client to pay additionally. If he does so, then you process the revision request and the compensation for it will be added as a bonus.',
    },
    'Why the status of the order does not change to Completed when I upload my final paper?': {
        title: 'Why the status of the order does not change to Completed when I upload my final paper?',
        category: 'submission',
        text: 'The status of the order automatically changes to Completed as per initial deadline and the compensation is transferred to Pending balance. If you upload the final paper before your actual deadline, it will be "In Work" status until your deadline comes, unless you ask our team leaders to complete it for you manually.',
    },
    'I cannot verify my Payoneer account. What should I do?': {
        title: 'I cannot verify my Payoneer account. What should I do?',
        category: 'paymentdetails',
        text: 'Please open the Guide "Payoneer" in your personal account and starting from the slide #14, it is explicitly shown what should be done from your side to successfully verify your Payoneer as a payment method.',
    },
    "Why can't I set a new payment method? It is said that this option is temporarily unavailable.": {
        title: "Why can't I set a new payment method? It is said that this option is temporarily unavailable.",
        category: 'paymentdetails',
        text: 'Please note that you cannot set up a new payment method 5 days before the withdrawal date. It means that this option is not available from 5th till 10th each month as well as from 20th till 25th.',
    },
    'Am I obliged to have 2 verified payment methods to get my money?': {
        title: 'Am I obliged to have 2 verified payment methods to get my money?',
        category: 'paymentdetails',
        text: 'It is not obligatory to have 2 payment methods verified to request a withdrawal. You are to have at least one option verified. We recommend having 2 methods for your financial security. If something goes wrong with one, you wiull have another one available as a back-up plan.',
    },
    'When will my salary be paid?': {
        title: 'When will my salary be paid?',
        category: 'paymentdetails',
        text: 'You are able to request your payments twice a month – by the 10th of each month and by the 25th of each month. That means that the latest time you can possibly request the payment is 23:59 on 9th and 23:59 on 24th. All requested payments will be processed within 10 days after the withdrawal deadline. For example, if you requested your payment on 9th, you will receive it by 20th of the same month. However, if you requested your payment on 10th, 1 a.m., it will be processed by the 5th of the following month, that is, in the next payment period.',
    },
    'What if I get a low grade but then the client wants his paper to be revised?': {
        title: 'What if I get a low grade but then the client wants his paper to be revised?',
        category: 'other',
        text: 'If you happen to receive a low grade, there is no need to rewrite the paper. These comments are for your future reference only not to repeat the same mistakes if there are any. Still, there are some cases when the client comes back asking to revise the paper after it has been graded. You are more than welcome to revise the paper both by grader&apos;s and client&apos;s comments. Afterwards, you are eligible to request you paper to be regraded. In order to do so, please contact our team leaders by sending a message in the system.',
    },
    'Why do I get calls from my team leaders during the night?': {
        title: 'Why do I get calls from my team leaders during the night?',
        category: 'other',
        text: 'Please make sure you set your current timezone in Settings, so you will not be bothered during the night. We contact you in case of necessity from 9 AM till 9 PM of your time unless you set your availability.',
    },
    'What does availability widget mean?': {
        title: 'What does availability widget mean?',
        category: 'other',
        text: 'It is an extremely useful option. We suggest our writers using it actively. If you set for how many hours you are available, it means that during this time frame you can be contacted for new recommendations by our Team Leaders, even during the early/late hours.',
    },
    'What is Lateness rate': {
        title: 'What is Lateness rate',
        category: 'quality',
        text: 'Percentage of orders in which you missed the deadline (based on 50 last completed orders).',
    },
    'What is Plagiarism rate': {
        title: 'What is Plagiarism rate',
        category: 'quality',
        text: 'Percentage of orders in which any level of plagiarism was found (based on 50 last completed orders).',
    },
    'What is Refund rate': {
        title: 'What is Refund rate',
        category: 'quality',
        text: 'Percentage of completed orders which were refunded per client request (based on 50 last completed orders).',
    },
    'Newbie': {
        title: 'Newbie',
        category: 'writer',
        text: 'Writers who completed less than 3 orders regardless of their score. <br/> A $5 bonus is paid for completing each of the first 3 orders within the specified time.<br/> Orders in progress total cost limit: $30.',
    },
    'Red': {
        title: 'Red',
        category: 'writer',
        text: 'Writers whose average grader score is below 70.<br/> No bonuses and limited access to available orders. The Company reserves a right to terminate writer’s account that has been in the red group for 2 months.',
    },
    'Basic': {
        title: 'Basic',
        category: 'writer',
        text: 'Writers whose average grader score is between 70 and 79. <br/> Orders in progress total cost limit: $150',
    },
    'Silver': {
        title: 'Silver',
        category: 'writer',
        text: 'Writers whose average grader score is between 80 and 89. <br/> Orders in progress total cost limit: $250',
    },
    'Gold': {
        title: 'Gold',
        category: 'writer',
        text: 'Writers whose average grader score is over 90.<br/> Unlimited access to available orders.<br/> Writers from this group get a 10% bonus for every order they complete',
    },
    'Cases for termination of cooperation': {
        title: 'Cases for termination of cooperation',
        category: 'termination',
        text: "The Company reserves a right to terminate cooperation and annual writer’s account (by notifying the Writer via email or phone) in the following cases: <ul><li>Disclosure of information considering orders, selling/donating/sharing papers with any third parties.</li><li>Using several user names or fake credentials.</li><li>Systematic violation of Writer's liabilities.</li></ul><br/>The Writer reserves a right to terminate cooperation at any time if he/she doesn't have any pending orders by notifying Team Leaders via email or phone. <br /><br />The Company reserves a right to terminate writer’s account that has been inactive for over 60 days.Inactivity means that the Writer did not login to their personal control panel for more than 1 month and/or did not complete any orders during a two-month period. The account may be re-opened upon Writer’s request and Company’s discretion. All earnings pending will be paid to the Writer within the nearest payment period if requested. <br /> The Company reserves a right to terminate writer’s account that has been in the red group for 2 months.",
    },
    'How to get assistance?': {
        title: 'How to get assistance?',
        category: 'contact',
        text: 'If you have any questions or need assistance, please, make sure to contact us (available 24/7). <br /><br />E-mail us:<br /><a href="mailto:support@liv-research.com">support@liv-research.com</a> (order-related issues)<br /><a href="mailto:success-team@liv-research.com">success-team@liv-research.com</a> (non-order related issues)<br /><br />Call us:<br /><a href="tel:+380957362473">+380957362473</a> for Ukraine<br /><a href="tel:+74991123285">+74991123285</a> for Russia<br />Skype: livingston_research for other countries',
    },
}

const guideList = {
    'Terms and Conditions & Privacy Policy': {
        title: 'Terms and Conditions & Privacy Policy',
        category: 'general',
        url: 'https://shift-files.s3.amazonaws.com/000/WritersAgreement2017.pdf',
        icon: 'pdf-icon'
    },
    ' Livingston Research Guide 2017': {
        title: ' Livingston Research Guide 2017',
        category: 'general',
        url: 'https://shift-files.s3.amazonaws.com/000/Livingston_Research_Guide_2017.pdf',
        icon: 'pdf-icon'
    },
    'Grading Rubric 2017': {
        title: 'Grading Rubric 2017',
        category: 'general',
        url: 'https://shift-files.s3.amazonaws.com/000/Grading_rubric.pdf',
        icon: 'pdf-icon'
    },
    'Multiple payment methods system guide': {
        title: 'Multiple payment methods system guide',
        category: 'paymentmethods',
        url: 'https://shift-files.s3.amazonaws.com/000/Guide+-+Payment+methods.pdf',
        icon: 'pdf-icon'
    },
    'Payoneer guide': {
        title: 'Payoneer guide',
        category: 'paymentmethods',
        url: 'https://shift-files.s3.amazonaws.com/000/Guide_Payoneer.pdf',
        icon: 'pdf-icon'
    },
    'How to register Skrill account': {
        title: 'How to register Skrill account',
        category: 'paymentmethods',
        url: 'https://shift-files.s3.amazonaws.com/000/Skrill+guide.pdf',
        icon: 'pdf-icon'
    },
    'Writing a research paper': {
        title: 'Writing a research paper',
        category: 'academicwriting',
        url: 'https://shift-files.s3.amazonaws.com/000/WRITING+A+RESEARCH+PAPER.docx',
        icon: 'docx-icon'
    },
    '10 common mistakes': {
        title: '10 common mistakes',
        category: 'academicwriting',
        url: 'https://shift-files.s3.amazonaws.com/000/10+Common+Mistakes.docx',
        icon: 'docx-icon'
    },
    'Guide to academic writing': {
        title: 'Guide to academic writing',
        category: 'academicwriting',
        url: 'https://shift-files.s3.amazonaws.com/000/Guide+to+Academic+Writing.docx',
        icon: 'docx-icon'
    },
    'Training on Thesis statement': {
        title: 'Training on Thesis statement',
        category: 'academicwriting',
        url: 'https://shift-files.s3.amazonaws.com/000/Training+on+Thesis+statement.docx',
        icon: 'docx-icon'
    },
    'Training on Structure': {
        title: 'Training on Structure',
        category: 'academicwriting',
        url: 'https://shift-files.s3.amazonaws.com/000/Training+on+Structure.pptx',
        icon: 'pptx-icon'
    },
    'Training on Sources Referencing': {
        title: 'Training on Sources Referencing',
        category: 'academicwriting',
        url: 'https://shift-files.s3.amazonaws.com/000/Training+on+Sources+Referencing.pptx',
        icon: 'pptx-icon'
    },
    'Training on Research methods': {
        title: 'Training on Research methods',
        category: 'academicwriting',
        url: 'https://shift-files.s3.amazonaws.com/000/Training+on+Research_methods.pdf',
        icon: 'pdf-icon'
    },
    'Databases & citing': {
        title: 'Databases & citing',
        category: 'academicwriting',
        url: 'https://shift-files.s3.amazonaws.com/000/Databases+%26+citing.pdf',
        icon: 'pdf-icon'
    },
    'PowerPoint training visual': {
        title: 'PowerPoint training visual',
        category: 'academicwriting',
        url: 'https://shift-files.s3.amazonaws.com/000/PowerPoint+training+visual.pdf',
        icon: 'pdf-icon'
    },
    'Training on Phrasing and tenses': {
        title: 'Training on Phrasing and tenses',
        category: 'academicwriting',
        url: 'https://shift-files.s3.amazonaws.com/000/Training+on+Phrasing_and_tenses_.pptx',
        icon: 'pptx-icon'
    },
    'APA template': {
        title: 'APA template',
        category: 'formattingstyles',
        url: 'https://shift-files.s3.amazonaws.com/000/APA+template.docx',
        icon: 'docx-icon'
    },
    'Chicago template': {
        title: 'Chicago template',
        category: 'formattingstyles',
        url: 'https://shift-files.s3.amazonaws.com/000/Chicago+template.docx',
        icon: 'docx-icon'
    },
    'Harvard template': {
        title: 'Harvard template',
        category: 'formattingstyles',
        url: 'https://shift-files.s3.amazonaws.com/000/Harvard+template.docx',
        icon: 'docx-icon'
    },
    'MLA template': {
        title: 'MLA template',
        category: 'formattingstyles',
        url: 'https://shift-files.s3.amazonaws.com/000/MLA+template.docx',
        icon: 'docx-icon'
    },
    'Bad example 1 (slides)': {
        title: 'Bad example 1 (slides)',
        category: 'badorders',
        url: 'https://shift-files.s3.amazonaws.com/000/bad_example_1_(slides).pptx',
        icon: 'pptx-icon'
    },
    'Bad example 2 (slides)': {
        title: 'Bad example 2 (slides)',
        category: 'badorders',
        url: 'https://shift-files.s3.amazonaws.com/000/bad_example_2_(slides).pptx',
        icon: 'pptx-icon'
    },
    'Bad example 3': {
        title: 'Bad example 3',
        category: 'badorders',
        url: 'https://shift-files.s3.amazonaws.com/000/bad_example_3.docx',
        icon: 'docx-icon'
    },
    'Bad example 4': {
        title: 'Bad example 4',
        category: 'badorders',
        url: 'https://shift-files.s3.amazonaws.com/000/bad_example_4.docx',
        icon: 'docx-icon'
    },
    'Good example 1': {
        title: 'Good example 1',
        category: 'goodorders',
        url: 'https://shift-files.s3.amazonaws.com/000/Good_example_1.docx',
        icon: 'docx-icon'
    },
    'Good example 2': {
        title: 'Good example 2',
        category: 'goodorders',
        url: 'https://shift-files.s3.amazonaws.com/000/Good_example_2.docx',
        icon: 'docx-icon'
    },
    'Good example 3': {
        title: 'Good example 3',
        category: 'goodorders',
        url: 'https://shift-files.s3.amazonaws.com/000/Good_example_3.docx',
        icon: 'docx-icon'
    },
    'Good example 4': {
        title: 'Good example 4',
        category: 'goodorders',
        url: 'https://shift-files.s3.amazonaws.com/000/Good_example_4.docx',
        icon: 'docx-icon'
    },
    'Good example 5 (slides)': {
        title: 'Good example 5',
        category: 'goodorders',
        url: 'https://shift-files.s3.amazonaws.com/000/Good_example_5_(slides).ppt',
        icon: 'pptx-icon'
    },
}

export default {
    faqCats,
    guidesCats,
    faqList,
    guideList
}


// WEBPACK FOOTER //
// ./src/store/help/data.js